import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { RefreshCw, Search, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { SourceBadge } from "@/components/SourceBadge";

const FILTERS = [["all", "Todos"], ["panel", "Painel IPTV"], ["ai", "IA"], ["error", "Erros"]];

const LogItem = ({ l }) => (
  <li className="log-item" data-testid={`log-item-${l.id}`}>
    <div className="flex items-center justify-between gap-2 flex-wrap">
      <div className="flex items-center gap-2 min-w-0">
        <p className="font-medium text-sm truncate">{l.sender}</p>
        {l.simulated && <span className="mono-badge border-[#1F2937] text-[#6B7280]">simulado</span>}
      </div>
      <div className="flex items-center gap-2">
        <SourceBadge source={l.source} />
        <span className="text-[11px] font-mono text-[#6B7280]">{new Date(l.created_at).toLocaleString("pt-BR")}</span>
      </div>
    </div>
    <p className="text-sm text-[#D1D5DB] mt-2"><span className="text-[#6B7280]">Cliente: </span>{l.message}</p>
    {l.replies.map((r, i) => <p key={i} className="text-sm text-[#9CA3AF] mt-1 whitespace-pre-wrap border-l-2 border-[#10B981]/40 pl-3">{r}</p>)}
    {l.error && <p className="text-xs text-red-400 mt-2 font-mono">{l.error}</p>}
  </li>
);

export const Logs = () => {
  const [source, setSource] = useState("all");
  const [q, setQ] = useState("");
  const [logs, setLogs] = useState([]);
  const load = useCallback(() => api.get("/logs", { params: { source, q } }).then((r) => setLogs(r.data)), [source, q]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);

  const clear = async () => {
    if (!window.confirm("Apagar todo o histórico?")) return;
    await api.delete("/logs"); load(); toast.success("Histórico apagado");
  };

  return (
    <div className="space-y-4" data-testid="logs-view">
      <div className="flex flex-col sm:flex-row gap-3 sm:items-center justify-between">
        <div className="flex gap-2 flex-wrap">
          {FILTERS.map(([v, t]) => (
            <button key={v} onClick={() => setSource(v)} className={`chip ${source === v ? "chip-active" : ""}`} data-testid={`logs-filter-${v}`}>{t}</button>
          ))}
        </div>
        <div className="flex gap-2">
          <div className="relative flex-1 sm:w-64">
            <Search className="w-4 h-4 absolute left-3 top-3 text-[#6B7280]" />
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar contato ou mensagem" className="input-dark pl-9 h-10" data-testid="logs-search-input" />
          </div>
          <Button variant="outline" size="icon" className="btn-ghost h-10 w-10" onClick={load} data-testid="logs-refresh-button"><RefreshCw className="w-4 h-4" /></Button>
          <Button variant="outline" size="icon" className="btn-ghost h-10 w-10 hover:text-red-400" onClick={clear} data-testid="logs-clear-button"><Trash2 className="w-4 h-4" /></Button>
        </div>
      </div>
      {logs.length === 0
        ? <p className="text-sm text-[#6B7280] py-16 text-center" data-testid="logs-empty">Nenhuma conversa ainda.</p>
        : <ul className="space-y-3" data-testid="logs-list">{logs.map((l) => <LogItem key={l.id} l={l} />)}</ul>}
    </div>
  );
};
